import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-339ff0af")

_pushScopeId("data-v-339ff0af")
const _hoisted_1 = { class: "pptist-screen" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_ScreenSlide = _resolveComponent("ScreenSlide")
  const _component_SlideThumbnails = _resolveComponent("SlideThumbnails")
  const _component_WritingBoardTool = _resolveComponent("WritingBoardTool")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "slide-list",
      style: _ctx.preview === 'preview'?{
      }:{
      }
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
        return (_openBlock(), _createBlock("div", {
          class: [
          'slide-item', 
          `turning-mode-${'slideY'}`,
          {
            'current': index === _ctx.slideIndex,
            'before': index < _ctx.slideIndex,
            'after': index > _ctx.slideIndex,
            'hide': (index === _ctx.slideIndex - 1 || index === _ctx.slideIndex + 1),
          }
        ],
          key: slide.id
        }, [
          _createVNode("div", {
            class: "slide-content",
            style: {
            width: _ctx.slideWidth + 'px',
            height: _ctx.slideHeight + 'px',
          }
          }, [
            _createVNode(_component_ScreenSlide, {
              slide: slide,
              scale: _ctx.scale,
              animationIndex: _ctx.animationIndex
            }, null, 8, ["slide", "scale", "animationIndex"])
          ], 4)
        ], 2))
      }), 128))
    ], 4),
    (_ctx.slideThumbnailModelVisible)
      ? (_openBlock(), _createBlock(_component_SlideThumbnails, {
          key: 0,
          turnSlideToIndex: _ctx.turnSlideToIndex,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.slideThumbnailModelVisible = false))
        }, null, 8, ["turnSlideToIndex"]))
      : _createCommentVNode("", true),
    (_ctx.writingBoardToolVisible)
      ? (_openBlock(), _createBlock(_component_WritingBoardTool, {
          key: 1,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.writingBoardToolVisible = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showPageNumber)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: "page-number",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.slideThumbnailModelVisible = true))
        }, _toDisplayString(_ctx.slideIndex + 1) + " / " + _toDisplayString(_ctx.slides.length), 1))
      : _createCommentVNode("", true)
  ]))
})